import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { OVERLAY_DATA } from '../overlay.constants';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@app/components/shared/icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { Role } from '@app/utils/interfaces/staff.interface';

@Component({
  selector: 'app-dropdown-overlay',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './dropdown-overlay.component.html',
  styleUrl: './dropdown-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownOverlayComponent {
  protected readonly IconName = IconName;

  public readonly dataInput = inject(OVERLAY_DATA);
  public readonly roles = this.dataInput.roles;
  public readonly selectedRoleId = signal(this.dataInput.selectedValue);

  public selectRole(role: Role): void {
    this.dataInput.onSelect(role);
  }
}
